import { useEffect, useState } from 'react';
import Title from '../../../componente/cadastro/titulo/index.jsx';
import Description from '../../../componente/cadastro/descricao/index.jsx';
import SearchField from '../../../componente/cadastro/busca/index.jsx';
import AddButton from '../../../componente/cadastro/botaoadd/index.jsx';
import Table from '../../../componente/cadastro/tabela/index.jsx';
import Pagination from '../../../componente/cadastro/paginacao/index.jsx';
import Sidebar from "../../../componente/sidebar/index.jsx";
import "./style.css";
import api from "../../../services/api.js";
import { useAppContext } from "../../context/AppContext.jsx";
import { toast } from 'react-hot-toast';
import Modal from "react-modal";
import ModalCliente from "react-modal";
import ModalCaixa from "react-modal";
import ModalMoeda from "react-modal";
import ModalCategoria from "react-modal";
import ModalBaixar from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import DuasDatas from '../../../componente/cadastro/duasdatas/index.jsx';
import AutoComplete1 from '../../../componente/cadastro/autocomplete/index.jsx';
import AutoComplete2 from '../../../componente/cadastro/autocomplete/index.jsx';
import AutoComplete3 from '../../../componente/cadastro/autocomplete/index.jsx';
import AutoComplete4 from '../../../componente/cadastro/autocomplete/index.jsx';
import AutoComplete5 from '../../../componente/cadastro/autocomplete/index.jsx';
import AutoComplete6 from '../../../componente/cadastro/autocomplete/index.jsx';
import { usePermissoes } from "../../../componente/permissoes";

Modal.setAppElement("#root");

const OpeContasReceber = () => {
    const { podeInserir, podeEditar, podeExcluir } = usePermissoes();

    const { DateTime } = require("luxon");
    const [search, setSearch] = useState('');
    const [filtroBusca, setFiltroBusca] = useState('A');

    // Função para calcular o primeiro dia do mês anterior
    const getFirstDayOfMonth = () => {
        const dt = new Date();
        dt.setMonth(dt.getMonth() - 1); // retrocede 1 mês
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-01`;
    };

    // Função para calcular a data atual + 2 meses
    const getCurrentDate = () => {
        const dt = new Date();
        dt.setMonth(dt.getMonth() + 2); // avança 2 meses
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-${dt.getDate().toString().padStart(2, "0")}`;
    };

    const [dt1, setdt1] = useState(getFirstDayOfMonth);
    const [dt2, setdt2] = useState(getCurrentDate);

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(50);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        total: 0,
        totalPages: 0
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showform, setshowform] = useState(false);
    const [showformcliente, setshowformcliente] = useState(false);
    const [showformcategoria, setshowformcategoria] = useState(false);
    const [showformcaixa, setshowformcaixa] = useState(false);
    const [showformmoeda, setshowformmoeda] = useState(false);
    const [showformbaixa, setshowformbaixa] = useState(false);
    const { accessKey, codassinante, codempresa, codusuario } = useAppContext(); // Acessa os dados do contexto          
    const [novo, setnovo] = useState(false);
    const [novocliente, setnovocliente] = useState(false);
    const [novocategoria, setnovocategoria] = useState(false);
    const [novocaixa, setnovocaixa] = useState(false);
    const [novomoeda, setnovomoeda] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [columns, setColumns] = useState([]);

    const menuOptions = [
        { label: "Imprimir", onClick: (item) => Imprimir(item) },
        { label: "Estornar Baixa", onClick: (item) => EstornarBaixa(item) },
        { label: "Baixa Receita", onClick: (item) => AbrirBaixaReceita(item) },
    ];

    //campos
    const [codcontasreceber, setCodContasReceber] = useState(0);
    const [dtvencimento, setDtVencimento] = useState("");
    const [parcela, setParcela] = useState(1);
    const [valororiginal, setValorOriginal] = useState(0);
    const [valordesconto, setValorDesconto] = useState(0);
    const [valorjuros, setValorJuros] = useState(0);
    const [valorliquido, setValorLiquido] = useState(0);
    const [historico, setHistorico] = useState("");
    const [codcliente, setCodCliente] = useState({ id: 0, label: "" });
    const [codcaixa, setCodCaixa] = useState({ id: 0, label: "" });
    const [codmoeda, setCodMoeda] = useState({ id: 0, label: "" });
    const [codcategoria, setCodCategoria] = useState({ id: 0, label: "" });
    const [recorrencia, setRecorrencia] = useState("0");
    const [intervalo, setIntervalo] = useState("");
    const [arquivos, setArquivos] = useState([]);

    //ModalBaixar
    const [dtbaixa, setDtBaixa] = useState("");
    const [codmoedabaixa, setCodMoedaBaixa] = useState({ id: 0, label: "" });
    const [codcaixabaixa, setCodCaixaBaixa] = useState({ id: 0, label: "" });
    const [valorliquidobaixa, setValorLiquidoBaixa] = useState(0);

    //Campo do Cliente
    const [tipocliente, setTipoCliente] = useState("");
    const [nome, setNome] = useState("");
    const [cpf, setCPF] = useState("");
    const [razaosocial, setRazaoSocial] = useState("");
    const [nomefantasia, setNomeFantasia] = useState("");
    const [cnpj, setCNPJ] = useState("");
    const [ie, setIE] = useState("");
    const [cep, setCEP] = useState("");
    const [endereco, setEndereco] = useState("");
    const [numero, setNumero] = useState("");
    const [complemento, setComplemento] = useState("");
    const [bairro, setBairro] = useState("");
    const [cidade, setCidade] = useState("");
    const [uf, setUF] = useState("");
    const [codcidade, setCodCidade] = useState("");
    const [pais, setPais] = useState("");
    const [codpais, setCodPais] = useState("");
    const [telefone, setTelefone] = useState("");
    const [whatsapp, setWhatsApp] = useState("");
    const [email, setEmail] = useState("");

    //Campos da categoria
    const [categoria, setCategoria] = useState("");
    const [tipo, setTipo] = useState("");

    //Campos do Caixa
    const [caixa, setCaixa] = useState("");

    //Campos da moeda
    const [moeda, setMoeda] = useState("");
    const [tipoMoeda, setTipoMoeda] = useState("");

    const handleFileUpload = async (event) => {
        const files = event.target.files;
        if (files.length === 0) return;

        try {
            setLoading(true);

            const uploadPromises = Array.from(files).map(async (file) => {
                // Converte o arquivo para Base64
                const base64 = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result.split(",")[1]);
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                });

                const payload = {
                    local: `Estofaria/AnexosReceitas/${codcliente.label}/${file.name}`,
                    nome: file.name,
                    base64,
                };

                const response = await api.post("/v1/operacao/upload", payload, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accessKey}`,
                    },
                });

                return response.data; // { codigo, nome, url, key }
            });

            const newFiles = await Promise.all(uploadPromises);
            setArquivos((prevArquivos) => [...prevArquivos, ...newFiles]);

            alert("Uploads realizados com sucesso!");
        } catch (error) {
            console.error("Erro no upload:", error);
            alert("Erro ao realizar o upload de um ou mais arquivos.");
        } finally {
            setLoading(false);
        }
    };

    const AbrirBaixaReceita = (cad) => {
        setCodContasReceber(cad.codcontasreceber);
        setCodMoedaBaixa({ id: cad.codmoeda, label: cad.moeda });
        setCodCaixaBaixa({ id: cad.codcaixa, label: cad.caixa });
        setValorLiquidoBaixa(cad.vlliquido);

        const dt = new Date();
        const date =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
        let time =
            dt.getHours().toString().padStart(2, "0") +
            ":" +
            dt.getMinutes().toString().padStart(2, "0") +
            ":" +
            dt.getSeconds().toString().padStart(2, "0");
        let dtcadastro = date + "T" + time;

        setDtBaixa(dtcadastro);

        setshowformbaixa(true);
    };

    const handleOpen = (cad) => {
        setCodContasReceber(cad.codcontasreceber);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        handleDelete();
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const fetchData = async (searchTerm, page, limit) => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get("/v1/operacao/contasreceber", {
                params: {
                    busca: searchTerm,
                    page,
                    per_page: limit,
                    codassinante,
                    codempresa,
                    dt1,
                    dt2,
                    filtrobusca: filtroBusca
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setData(response.data.data);
            setPagination({
                total: response.data.pagination.Total,
                totalPages: response.data.pagination.TotalPages
            });
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            fetchData(search, currentPage, perPage);
        }, 1000); // Aguarda 1 segundo após o usuário parar de digitar

        // Cleanup function para limpar o timeout anterior
        return () => clearTimeout(timeoutId);
    }, [search, currentPage, perPage, codempresa, filtroBusca, dt1, dt2]);

    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
        setCurrentPage(1); // Volta para primeira página ao mudar quantidade
    };

    const handleEdit = async (user) => {
        try {
            setLoading(true);
            setError(null);

            const response = await api.get("/v1/operacao/contasreceberum", {
                params: {
                    codcontasreceber: user.codcontasreceber
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            setshowform(true);
            setnovo(false);

            const formatDate = (dateStr) =>
                dateStr
                    ? DateTime.fromISO(dateStr).plus({ hours: 3 }).toFormat("yyyy-MM-dd")
                    : "";

            setCodContasReceber(user.codcontasreceber);
            setDtVencimento(formatDate(response.data.receita.dtvencimento));
            setCodCliente({ id: response.data.receita.codcliente, label: response.data.receita.cliente });
            setCodCategoria({ id: response.data.receita.codcategoria, label: response.data.receita.categoria });
            setCodCaixa({ id: response.data.receita.codcaixa, label: response.data.receita.caixa });
            setCodMoeda({ id: response.data.receita.codmoeda, label: response.data.receita.moeda });
            setHistorico(response.data.receita.historico);
            setValorOriginal(response.data.receita.vloriginal);
            setValorDesconto(response.data.receita.vldesconto);
            setValorJuros(response.data.receita.vljuros);
            setValorLiquido(response.data.receita.vlliquido);

            setArquivos(Array.isArray(response.data.anexo)
                ? response.data.anexo.map(it => ({
                    codigo: it.codigo || 0,
                    nome: it.nome || "",
                    url: it.url || "",
                    key: it.key || ""
                }))
                : []);

        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        try {
            setLoading(true);
            setError(null);
            await api.delete("/v1/operacao/contasreceber", {
                params: {
                    codcontasreceber,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            fetchData(search, currentPage, perPage);
            toast.success('Excluído com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = async () => {
        try {
            setLoading(true);
            setError(null);

            setshowform(true);
            setnovo(true);

            setCodContasReceber(0);

            const dt = new Date();
            const date =
                dt.getFullYear() +
                "-" +
                (dt.getMonth() + 1).toString().padStart(2, "0") +
                "-" +
                dt.getDate().toString().padStart(2, "0");
            let dtcadastro = date;

            setDtVencimento(dtcadastro);
            setCodCliente({ id: 0, label: "" });
            setCodCategoria({ id: 0, label: "" });
            setCodCaixa({ id: 0, label: "" });
            setCodMoeda({ id: 0, label: "" });
            setHistorico("");
            setValorOriginal(0);
            setValorDesconto(0);
            setValorJuros(0);
            setValorLiquido(0);
            setRecorrencia("0");
            setIntervalo(1);
            setParcela("1");
            setArquivos([]);

        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    function Salvar() {
        if (codcaixa.id === 0) {
            alert('Informe o caixa antes de salvar');
        } else if (codmoeda.id === 0) {
            alert('Informe a condição de recebimento antes de salvar');
        } else if (codcategoria.id === 0) {
            alert('Informe a categoria antes de salvar');
        } else {
            novo ? Cadastrar() : Editar();
            setshowform(false);
        }
    };

    function SalvarCliente() {
        novocliente ? CadastrarCliente() : EditarCliente();

        setshowformcliente(false);
    }

    async function CadastrarCliente() {
        try {
            setLoading(true);
            setError(null);

            if (codempresa === 0) {
                alert('Selecione a filial antes!');
                return; // <-- impede que continue para o POST
            }

            const response = await api.post("v1/cad/cliente", {
                tipocliente,
                nome,
                cpf,
                razaosocial,
                nomefantasia,
                cnpj,
                ie,
                cep,
                endereco,
                numero,
                complemento,
                bairro,
                cidade,
                uf,
                codcidade,
                pais,
                codpais,
                telefone,
                whatsapp,
                email,
                codempresa,
                excluido: "N",
                codassinante,
                codusuario,
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });

            setCodCliente({ id: response.data.codcliente, label: tipocliente === 'J' ? razaosocial : nome })

            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    async function EditarCliente() {
        try {
            setLoading(true);
            setError(null);
            await api.put("v1/cad/cliente", {
                tipocliente,
                nome,
                cpf,
                razaosocial,
                nomefantasia,
                cnpj,
                ie,
                cep,
                endereco,
                numero,
                complemento,
                bairro,
                cidade,
                uf,
                codcidade,
                pais,
                codpais,
                telefone,
                whatsapp,
                email,
                codcliente
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            fetchData(search, currentPage, perPage);
            toast.success('Edição feita com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }    

    async function SalvarCategoria() {
        try {
            setLoading(true);
            setError(null);

            if (codempresa === 0) {
                alert('Selecione a filial antes!');
                return; // <-- impede que continue para o POST
            }

            const response = await api.post("v1/cad/categoria", {
                descricao: categoria,
                tipo,
                codempresa,
                excluido: "N",
                codassinante,
                codusuario,
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            setCodCategoria({ id: response.data.codcategoria, label: categoria });
            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
            setshowformcategoria(false);
        }
    }

    async function SalvarCaixa() {
        try {
            setLoading(true);
            setError(null);

            if (codempresa === 0) {
                alert('Selecione a filial antes!');
                return; // <-- impede que continue para o POST
            }

            const response = await api.post("v1/cad/caixa", {
                caixa,
                codempresa,
                excluido: "N",
                codassinante,
                codusuario,
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            showform ? setCodCaixa({ id: response.data.codcaixa, label: caixa }) : setCodCaixaBaixa({ id: response.data.codcaixa, label: caixa });
            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
            setshowformcaixa(false);
        }
    }

    async function SalvarMoeda() {
        try {
            setLoading(true);
            setError(null);

            if (codempresa === 0) {
                alert('Selecione a filial antes!');
                return; // <-- impede que continue para o POST
            }

            const response = await api.post("v1/cad/moeda", {
                descricao: moeda,
                tipo,
                codempresa,
                excluido: "N",
                codassinante,
                codusuario,
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            showform ? setCodMoeda({ id: response.data.codmoeda, label: moeda }) : setCodMoedaBaixa({ id: response.data.codmoeda, label: moeda });
            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
            setshowformmoeda(false);
        }
    }

    async function Editar() {
        try {
            setLoading(true);
            setError(null);
            await api.put("/v1/operacao/contasreceber", {
                codcontasreceber,
                codcliente: codcliente.id,
                codcategoria: codcategoria.id,
                codcaixa: codcaixa.id,
                codmoeda: codmoeda.id,
                historico,
                vloriginal: valororiginal,
                vldesconto: valordesconto,
                vljuros: valorjuros,
                vlliquido: valorliquido,
                dtvencimento,
                arquivos
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });
            fetchData(search, currentPage, perPage);
            toast.success('Edição feita com Sucesso!');
        } catch (error) {
            console.error('Erro ao excluir dados:', error);
            setError('Erro ao tentar excluir os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    async function Cadastrar() {
        try {
            setLoading(true);
            setError(null);

            if (codempresa === 0) {
                alert('Selecione a filial antes!');
                return; // <-- impede que continue para o POST
            }

            await api.post("/v1/operacao/contasreceber", {
                codcliente: codcliente.id,
                codcategoria: codcategoria.id,
                codcaixa: codcaixa.id,
                codmoeda: codmoeda.id,
                historico,
                vloriginal: valororiginal,
                vldesconto: valordesconto,
                vljuros: valorjuros,
                vlliquido: valorliquido,
                parcela,
                dtvencimento,
                codempresa,
                excluido: "N",
                codassinante,
                codusuario,
                intervalo,
                recorrencia,
                arquivos
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });

            fetchData(search, currentPage, perPage);
            toast.success('Registro Salvo com Sucesso!');
        } catch (error) {
            console.error('Erro ao cadastrar pedido:', error);
            setError('Erro ao tentar salvar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    const fetchDataCliente = async (query) => {
        try {
            const response = await api.get("/v1/busca/cliente", {
                params: {
                    busca: query,
                    codassinante,
                    codempresa
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            return response.data; // Retorna diretamente os dados da API

        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            toast.error('Ocorreu algum erro! ❌');
            return []; // Retorna um array vazio em caso de erro
        }
    };

    const handleAddCliente = () => {
        setnovocliente(true);
        setshowformcliente(true);

        setCodCliente({ id: 0, label: "" });
        setTipoCliente('F')
        setNome('');
        setCPF('');
        setRazaoSocial('');
        setNomeFantasia('');
        setCNPJ('');
        setIE('');
        setCEP('');
        setEndereco('');
        setNumero('');
        setComplemento('');
        setBairro('');
        setCidade('');
        setUF('');
        setCodCidade('');
        setPais('Brasil');
        setCodPais('1058');
        setTelefone('');
        setWhatsApp('');
        setEmail('');
    };

    const fetchDataCategoria = async (query) => {
        try {
            const response = await api.get("/v1/busca/categoria", {
                params: {
                    busca: query,
                    codassinante,
                    codempresa
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            return response.data; // Retorna diretamente os dados da API

        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            toast.error('Ocorreu algum erro! ❌');
            return []; // Retorna um array vazio em caso de erro
        }
    };

    const handleAddCategoria = () => {
        setshowformcategoria(true);
        setnovocategoria(true);

        setCodCategoria({ id: 0, label: "" });
        setCategoria('');
        setTipo('R');
    };

    const fetchDataCaixa = async (query) => {
        try {
            const response = await api.get("/v1/busca/caixa", {
                params: {
                    busca: query,
                    codassinante,
                    codempresa // Usa o código recebido por parâmetro
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            return response.data; // Retorna diretamente os dados da API
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        }
    };

    const handleAddCaixa = () => {
        setshowformcaixa(true);
        setnovocaixa(true);

        setCodCaixa({ id: 0, label: "" });
        setCaixa('');
    };

    const handleAddCaixaBaixa = () => {
        setshowformcaixa(true);
        setnovocaixa(true);

        setCodCaixaBaixa({ id: 0, label: "" });
        setCaixa('');
    };

    const fetchDataMoeda = async () => {
        try {
            const response = await api.get("/v1/busca/moeda", {
                params: {
                    codassinante,
                    codempresa // Usa o código recebido por parâmetro
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            return response.data; // Retorna diretamente os dados da API
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        }
    };

    const handleAddMoeda = () => {
        setshowformmoeda(true);
        setnovomoeda(true);

        setCodMoeda({ id: 0, label: "" });
        setMoeda('');
        setTipoMoeda('DI');
    };

    const handleAddMoedaBaixa = () => {
        setshowformmoeda(true);
        setnovomoeda(true);

        setCodMoedaBaixa({ id: 0, label: "" });
        setMoeda('');
        setTipoMoeda('DI');
    };

    async function Imprimir(item) {
        setLoading(true);

        try {
            const response = await api.get(`v1/imp/contaspagar`, {
                responseType: "arraybuffer",
                params: {
                    codpedido: item.codpedido
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.click();
        } catch (error) {
            console.log("ops! ocorreu um erro: " + error);
        } finally {
            setLoading(false);
        }
    }

    async function EstornarBaixa(item) {
        try {
            setLoading(true);
            setError(null);

            await api.post("/v1/operacao/estornarbaixa", {
                codigo: item.codcontasreceber,
                tipo: 'receita'
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });

            fetchData(search, currentPage, perPage);
            toast.success('Registro Estornado com Sucesso!');
        } catch (error) {
            console.error('Erro ao estornar contas a pagar:', error);
            setError('Erro ao tentar estornar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    async function BaixarReceita() {
        try {
            setLoading(true);
            setError(null);

            await api.post("/v1/operacao/baixar", {
                codigo: codcontasreceber,
                valor: valorliquidobaixa,
                dtbaixa,
                tipo: 'receita',
                codmoeda: codmoedabaixa.id,
                codcaixa: codcaixabaixa.id
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });

            setshowformbaixa(false);
            fetchData(search, currentPage, perPage);
            toast.success('Registro Baixado com Sucesso!');
        } catch (error) {
            console.error('Erro ao baixar contas a pagar:', error);
            setError('Erro ao tentar baixar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    async function BaixarReceitaParcial() {
        try {
            setLoading(true);
            setError(null);

            await api.post("/v1/operacao/baixarpacial", {
                codigo: codcontasreceber,
                valor: valorliquidobaixa,
                dtbaixa,
                tipo: 'receita',
                codmoeda: codmoedabaixa.id,
                codcaixa: codcaixabaixa.id,
                codusuario
            },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },

                });

            fetchData(search, currentPage, perPage);
            toast.success('Registro com Baixa Parcial feito com Sucesso!');
        } catch (error) {
            console.error('Erro ao baixar parcial o contas a pagar:', error);
            setError('Erro ao tentar baixar parcial dos dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    }

    const consultarCep = async () => {
        try {
            const cepLimpo = cep.replace(/\D/g, "");
            if (cepLimpo.length !== 8) {
                alert("CEP inválido!");
                return;
            }

            const { data } = await api.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);

            if (data.erro) {
                alert("CEP não encontrado!");
                return;
            }

            setEndereco(data.logradouro);
            setComplemento(data.complemento);
            setBairro(data.bairro);
            setCidade(data.localidade);
            setUF(data.uf);
            setCodCidade(data.ibge)
        } catch (error) {
            console.error("Erro ao consultar CEP:", error);
            alert("Não foi possível buscar o CEP.");
        }
    };

    const consultarCnpj = async () => {
        if (!cnpj || cnpj.length < 14) {
            alert("Informe um CNPJ válido!");
            return;
        }

        try {
            const { data } = await api.get(`https://brasilapi.com.br/api/cnpj/v1/${cnpj.replace(/\D/g, "")}`);


            setRazaoSocial(data.razao_social);
            setNomeFantasia(data.nome_fantasia);
            setIE(data.inscricao_estadual);
            setCEP(data.cep);
            setEndereco(data.logradouro);
            setNumero(data.numero);
            setBairro(data.bairro);
            setCidade(data.municipio);
            setUF(data.uf);


        } catch (error) {
            console.error(error);
            alert("Erro ao consultar CNPJ. Verifique se é válido.");
        }
    };

    const handleRemoveFile = async (indexToRemove) => {
        const fileToRemove = arquivos[indexToRemove];

        if (!fileToRemove || !fileToRemove.key) {
            console.error("Arquivo não encontrado ou sem chave S3.");
            return;
        }

        try {
            setLoading(true);

            // 🔐 Envia requisição à API Delphi para remover do S3
            await api.delete("/v1/operacao/removeranexo", {
                params: {
                    key: fileToRemove.key, // exemplo: Estofaria/AnexosDespesas/arquivo.png
                    tipo: 'contasreceber',
                    codigo: fileToRemove.codigo,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            // Remove localmente após sucesso
            setArquivos(prevArquivos =>
                prevArquivos.filter((_, index) => index !== indexToRemove)
            );
            toast.success("Arquivo removido com sucesso!");
        } catch (error) {
            console.error("Erro ao remover arquivo:", error);
            toast.error("Erro ao remover o arquivo ❌");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (filtroBusca === "P") {
            setColumns([
                { key: "dtlancamento", title: "Lançamento", type: "date" },
                { key: "dtvencimento", title: "Vencimento", type: "date" },
                { key: "dtbaixa", title: "Baixa", type: "date" },
                { key: "parcela", title: "Parcela" },
                { key: "cliente", title: "Cliente" },
                { key: "numpedido", title: "Pedido" },
                { key: "historico", title: "Histórico" },
                { key: "moeda", title: "Condição" },
                { key: "empresa", title: "Empresa" },
                { key: "observacao", title: "Obs." },
                { key: "vlliquido", title: "Valor", type: "float" },
            ]);
        } else {
            setColumns([
                { key: "dtlancamento", title: "Lançamento", type: "date" },
                { key: "dtvencimento", title: "Vencimento", type: "date" },
                { key: "parcela", title: "Parcela" },
                { key: "cliente", title: "Cliente" },
                { key: "numpedido", title: "Pedido" },
                { key: "historico", title: "Histórico" },
                { key: "moeda", title: "Condição" },
                { key: "empresa", title: "Empresa" },
                { key: "observacao", title: "Obs." },
                { key: "vlliquido", title: "Valor", type: "float" },
            ]);
        }
    }, [filtroBusca]);

    const extraIcons = [
        { field: "anexo", icon: "fa-solid fa-paperclip" },
        { field: "pago", title: "#", icon: "fa-solid fa-dollar-sign" }
    ]

    const handleEditCliente = async (user) => {
        try {
            setLoading(true);
            setError(null);
            const response = await api.get("v1/cad/clienteum", {
                params: {
                    codcliente: user.id
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });
            setshowformcliente(true);
            setnovocliente(false);

            setCodCliente(user.id);
            setTipoCliente(response.data.tipocliente)
            setNome(response.data.nome);
            setCPF(response.data.cpf);
            setRazaoSocial(response.data.razaosocial);
            setNomeFantasia(response.data.nomefantasia);
            setCNPJ(response.data.cnpj);
            setIE(response.data.ie);
            setCEP(response.data.cep);
            setEndereco(response.data.endereco);
            setNumero(response.data.numero);
            setComplemento(response.data.complemento);
            setBairro(response.data.bairro);
            setCidade(response.data.cidade);
            setUF(response.data.uf);
            setCodCidade(response.data.codcidade);
            setPais(response.data.pais);
            setCodPais(response.data.codpais);
            setTelefone(response.data.telefone);
            setWhatsApp(response.data.whatsapp);
            setEmail(response.data.email);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setError('Erro ao carregar os dados. Tente novamente.');
            toast.error('Ocorreu algum erro! ❌');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="app-container">
                <Sidebar />
                <main className="content-container">
                    <PopUp isOpen={isOpen} onClose={handleClose}>
                        <h2>Verificação</h2>
                        <p>Tem certeza que deseja excluir esse registro?</p>

                        <div className="row">
                            <div className="col-12 mt-3 d-flex justify-content-end">
                                <button
                                    className="btn btn-primary me-2"
                                    onClick={handleConfirma}
                                >
                                    Sim
                                </button>
                                <button className="btn btn-danger" onClick={handleClose}>
                                    Não
                                </button>
                            </div>
                        </div>
                    </PopUp>

                    <Modal
                        isOpen={showform}
                        onRequestClose={() => setshowform(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-xl"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro </h2>}
                                <button type="button" className="btn-close" onClick={() => setshowform(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <AutoComplete1
                                                    fetchData={fetchDataCliente}
                                                    onSelect={(item) =>
                                                        setCodCliente(item ? { id: item.id, label: item.label } : { id: 0, label: "" })
                                                    }
                                                    onAdd={handleAddCliente}
                                                    onView={(item) => handleEditCliente(item)}
                                                    txtLabel={"Cliente"}
                                                    initialValue={
                                                        codcliente
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <AutoComplete2
                                                    fetchData={fetchDataCategoria}
                                                    onSelect={(item) =>
                                                        setCodCategoria(item ? { id: item.id, label: item.label } : { id: 0, label: "" })
                                                    }
                                                    onAdd={handleAddCategoria}
                                                    txtLabel={"Categoria"}
                                                    initialValue={
                                                        codcategoria
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <AutoComplete3
                                                    fetchData={fetchDataCaixa}
                                                    onSelect={(item) =>
                                                        setCodCaixa(item ? { id: item.id, label: item.label } : { id: 0, label: "" })
                                                    }
                                                    onAdd={handleAddCaixa}
                                                    txtLabel={"Caixa"}
                                                    initialValue={
                                                        codcaixa
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <AutoComplete4
                                                    fetchData={fetchDataMoeda}
                                                    onSelect={(item) =>
                                                        setCodMoeda(item ? { id: item.id, label: item.label } : { id: 0, label: "" })
                                                    }
                                                    onAdd={handleAddMoeda}
                                                    txtLabel={"Condição"}
                                                    initialValue={
                                                        codmoeda
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <textarea
                                                    className="form-control"
                                                    style={{ height: "150px" }}
                                                    id="historico"
                                                    rows={10}
                                                    value={historico}
                                                    onChange={(e) => setHistorico(e.target.value)}
                                                />
                                                <label htmlFor="historico">Histórico</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="valororiginal"
                                                    value={valororiginal}
                                                    onChange={(e) => {
                                                        const val = isNaN(e.target.valueAsNumber) ? 0 : e.target.valueAsNumber;
                                                        setValorOriginal(val);
                                                        setValorLiquido(val - valordesconto + valorjuros);
                                                    }}
                                                />
                                                <label htmlFor="valororiginal">Vl. Original</label>
                                            </div>
                                        </div>

                                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="valordesconto"
                                                    value={valordesconto}
                                                    onChange={(e) => {
                                                        const val = isNaN(e.target.valueAsNumber) ? 0 : e.target.valueAsNumber;
                                                        setValorDesconto(val);
                                                        setValorLiquido(valororiginal - val + valorjuros);
                                                    }}
                                                />
                                                <label htmlFor="valororiginal">Vl. Desconto</label>
                                            </div>
                                        </div>

                                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="valorjuros"
                                                    value={valorjuros}
                                                    onChange={(e) => {
                                                        const val = isNaN(e.target.valueAsNumber) ? 0 : e.target.valueAsNumber;
                                                        setValorJuros(val);
                                                        setValorLiquido(valororiginal - valordesconto + val);
                                                    }}
                                                />
                                                <label htmlFor="valorjuros">Vl. Juros</label>
                                            </div>
                                        </div>

                                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="valorliquido"
                                                    value={valorliquido}
                                                    disabled
                                                />
                                                <label htmlFor="valorliquido">Vl. Líquido</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                            <div className="form-floating">
                                                <select
                                                    className="form-select"
                                                    id="recorrencia"
                                                    value={recorrencia}
                                                    onChange={(e) => setRecorrencia(e.target.value)}
                                                    disabled={!novo}
                                                >
                                                    <option value="0">Único</option>
                                                    <option value="1">Pacelado (Diário)</option>
                                                    <option value="2">Semanal</option>
                                                    <option value="3">Quinzenal</option>
                                                    <option value="4">Mensal</option>
                                                    <option value="5">Bimestral</option>
                                                    <option value="6">Trimestral</option>
                                                    <option value="7">Semestral</option>
                                                    <option value="8">Anual</option>
                                                </select>
                                                <label htmlFor="recorrencia">Recorrência</label>
                                            </div>
                                        </div>

                                        {recorrencia === "1" && (<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="intervalo"
                                                    value={intervalo}
                                                    onChange={(e) => setIntervalo(e.target.value)}
                                                    placeholder='0 30 60 90'
                                                    disabled={!novo}
                                                />
                                                <label htmlFor="intervalo">Intervalo (Dias)</label>
                                            </div>
                                        </div>)}

                                        {recorrencia !== "0" && (<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="parcela"
                                                    value={parcela}
                                                    onChange={(e) => setParcela(e.target.value)}
                                                    placeholder='1'
                                                    disabled={!novo}
                                                />
                                                <label htmlFor="parcela">Qtde Parcelas</label>
                                            </div>
                                        </div>)}

                                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2">
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    id="dtvencimento"
                                                    value={dtvencimento}
                                                    onChange={(e) => setDtVencimento(e.target.value)}
                                                />
                                                <label htmlFor="dtvencimento">1º Vencimento</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="file"
                                                    id="anexos"
                                                    onChange={handleFileUpload}
                                                    multiple // Adiciona o atributo multiple aqui
                                                />
                                                <label htmlFor="anexos">Anexar Arquivos</label>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Lista de Anexos */}
                                    {arquivos.length > 0 && (
                                        <div className='row mt-3'>
                                            <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12'>
                                                <h5>Anexos:</h5>
                                                <ul className="list-group">
                                                    {arquivos.map((anexo, index) => (
                                                        <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                            <a href={anexo.url} target="_blank" rel="noopener noreferrer">
                                                                {anexo.nome}
                                                            </a>
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() => handleRemoveFile(index)}
                                                            >
                                                                Remover
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowform(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={Salvar} >
                                    Salvar
                                </button>

                            </div>
                        </div>
                    </Modal>

                    <ModalBaixar
                        isOpen={showformbaixa}
                        onRequestClose={() => setshowformbaixa(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-md"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                <h2>Baixa de Recita</h2>
                                <button type="button" className="btn-close" onClick={() => setshowformbaixa(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <AutoComplete5
                                                    fetchData={fetchDataCaixa}
                                                    onSelect={(item) =>
                                                        setCodCaixaBaixa(item ? { id: item.id, label: item.label } : { id: 0, label: "" })
                                                    }
                                                    onAdd={handleAddCaixaBaixa}
                                                    txtLabel={"Caixa"}
                                                    initialValue={
                                                        codcaixabaixa
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <AutoComplete6
                                                    fetchData={fetchDataMoeda}
                                                    onSelect={(item) =>
                                                        setCodMoedaBaixa(item ? { id: item.id, label: item.label } : { id: 0, label: "" })
                                                    }
                                                    onAdd={handleAddMoedaBaixa}
                                                    txtLabel={"Condição"}
                                                    initialValue={
                                                        codmoedabaixa
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="datetime-local"
                                                    id="dtbaixa"
                                                    value={dtbaixa}
                                                    onChange={(e) => setDtBaixa(e.target.value)}
                                                />
                                                <label htmlFor="dtbaixa">Dt. Baixa</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="number"
                                                    id="valorliquidobaixa"
                                                    value={valorliquidobaixa}
                                                    onChange={(e) => setValorLiquidoBaixa(e.target.value)}
                                                />
                                                <label htmlFor="valorliquidobaixa">Vl. de Baixa</label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowformbaixa(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={BaixarReceita} >
                                    Baixar total
                                </button>
                                <button type="button" className="btn btn-success" onClick={BaixarReceitaParcial} >
                                    Baixar parcial
                                </button>

                            </div>
                        </div>
                    </ModalBaixar>

                    <ModalCliente
                        isOpen={showformcliente}
                        onRequestClose={() => setshowformcliente(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-xl"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novocliente ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
                                <button type="button" className="btn-close" onClick={() => setshowformcliente(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-group">
                                                <label className="form-label">Tipo de Cliente</label>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="pessoaJuridica"
                                                        name="tipoFornecedor"
                                                        value="J"
                                                        checked={tipocliente === "J"}
                                                        onChange={(e) => setTipoCliente(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="pessoaJuridica">
                                                        Pessoa Jurídica
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="pessoaFisica"
                                                        name="tipoFornecedor"
                                                        value="F"
                                                        checked={tipocliente === "F"}
                                                        onChange={(e) => setTipoCliente(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="pessoaFisica">
                                                        Pessoa Física
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        {tipocliente === 'J' ?
                                            (<>
                                                <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="razaosocial"
                                                            value={razaosocial}
                                                            onChange={(e) => setRazaoSocial(e.target.value)}
                                                        />
                                                        <label htmlFor="razaosocial">Razão Social</label>
                                                    </div>
                                                </div>
                                                <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="nomefantasia"
                                                            value={nomefantasia}
                                                            onChange={(e) => setNomeFantasia(e.target.value)}
                                                        />
                                                        <label htmlFor="nomefantasia">Nome Fantasia</label>
                                                    </div>
                                                </div>
                                                <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating input-group">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="CNPJ"
                                                            value={cnpj}
                                                            onChange={(e) => setCNPJ(e.target.value)}
                                                        />
                                                        <label htmlFor="cnpj">CNPJ</label>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-secondary"
                                                            onClick={consultarCnpj}
                                                        >
                                                            <i className="fa fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="ie"
                                                            value={ie}
                                                            onChange={(e) => setIE(e.target.value)}
                                                        />
                                                        <label htmlFor="ie">Ins. Estadual</label>
                                                    </div>
                                                </div>
                                            </>
                                            )
                                            :
                                            (<>
                                                <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="nome"
                                                            value={nome}
                                                            onChange={(e) => setNome(e.target.value)}
                                                        />
                                                        <label htmlFor="nome">Nome</label>
                                                    </div>
                                                </div>
                                                <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                                    <div className="form-floating">
                                                        <input
                                                            className="form-control"
                                                            type="text"
                                                            id="cpf"
                                                            value={cpf}
                                                            onChange={(e) => setCPF(e.target.value)}
                                                        />
                                                        <label htmlFor="cpf">CPF</label>
                                                    </div>
                                                </div>
                                            </>)
                                        }

                                    </div>

                                    <div className='row'>
                                        <div className="col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2">
                                            <div className="form-floating input-group">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="cep"
                                                    id="cep"
                                                    value={cep}
                                                    onChange={(e) => setCEP(e.target.value)}
                                                />
                                                <label htmlFor="cep">CEP</label>
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary"
                                                    onClick={consultarCep}
                                                >
                                                    <i className="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div className='col-xl-5 col-lg-5 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="endereco"
                                                    id="endereco"
                                                    value={endereco}
                                                    onChange={(e) => setEndereco(e.target.value)}
                                                />
                                                <label htmlFor="endereco">Endereço</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-1 col-lg-1 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="numero"
                                                    id="numero"
                                                    value={numero}
                                                    onChange={(e) => setNumero(e.target.value)}
                                                />
                                                <label htmlFor="numero">Núm.</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="complemento"
                                                    id="complemento"
                                                    value={complemento}
                                                    onChange={(e) => setComplemento(e.target.value)}
                                                />
                                                <label htmlFor="complemento">Complemento</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="bairro"
                                                    id="bairro"
                                                    value={bairro}
                                                    onChange={(e) => setBairro(e.target.value)}
                                                />
                                                <label htmlFor="bairro">Bairro</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-5 col-lg-5 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="cidade"
                                                    id="cidade"
                                                    value={cidade}
                                                    onChange={(e) => setCidade(e.target.value)}
                                                />
                                                <label htmlFor="cidade">Cidade</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-1 col-lg-1 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="uf"
                                                    id="uf"
                                                    value={uf}
                                                    onChange={(e) => setUF(e.target.value)}
                                                />
                                                <label htmlFor="uf">UF</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="codcidade"
                                                    id="codcidade"
                                                    value={codcidade}
                                                    onChange={(e) => setCodCidade(e.target.value)}
                                                />
                                                <label htmlFor="codcidade">Cód. IBGE Cida.</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-5 col-lg-5 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="pais"
                                                    id="pais"
                                                    value={pais}
                                                    onChange={(e) => setPais(e.target.value)}
                                                />
                                                <label htmlFor="pais">País</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-2 col-lg-2 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="codpais"
                                                    id="codpais"
                                                    value={codpais}
                                                    onChange={(e) => setCodPais(e.target.value)}
                                                />
                                                <label htmlFor="codpais">Cód. IBGE País</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="telefone"
                                                    id="telefone"
                                                    value={telefone}
                                                    onChange={(e) => setTelefone(e.target.value)}
                                                />
                                                <label htmlFor="telefone">Telefone</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-3 col-lg-3 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="whatsapp"
                                                    id="whatsapp"
                                                    value={whatsapp}
                                                    onChange={(e) => setWhatsApp(e.target.value)}
                                                />
                                                <label htmlFor="whatsapp">WhatsApp</label>
                                            </div>
                                        </div>

                                        <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="email"
                                                    id="email"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                                <label htmlFor="email">E-mail</label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowformcliente(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={SalvarCliente}>
                                    Salvar
                                </button>

                            </div>
                        </div>
                    </ModalCliente>

                    <ModalCategoria
                        isOpen={showformcategoria}
                        onRequestClose={() => setshowformcategoria(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-xl"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novocategoria ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
                                <button type="button" className="btn-close" onClick={() => setshowformcategoria(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="categoria"
                                                    value={categoria}
                                                    onChange={(e) => setCategoria(e.target.value)}
                                                />
                                                <label htmlFor="categoria">Categoria</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-group">
                                                <label className="form-label">Tipo de Categoria</label>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="receita"
                                                        name="tipo"
                                                        value="R"
                                                        checked={tipo === "R"}
                                                        onChange={(e) => setTipo(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="receita">
                                                        Receita
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="despesa"
                                                        name="tipo"
                                                        value="D"
                                                        checked={tipo === "D"}
                                                        onChange={(e) => setTipo(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="despesa">
                                                        Despesa
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowformcategoria(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={SalvarCategoria}>
                                    Salvar
                                </button>

                            </div>
                        </div>
                    </ModalCategoria>

                    <ModalCaixa
                        isOpen={showformcaixa}
                        onRequestClose={() => setshowformcaixa(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-xl"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novocaixa ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
                                <button type="button" className="btn-close" onClick={() => setshowformcaixa(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="caixa"
                                                    value={caixa}
                                                    onChange={(e) => setCaixa(e.target.value)}
                                                />
                                                <label htmlFor="caixa">Caixa</label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowformcaixa(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={SalvarCaixa}>
                                    Salvar
                                </button>

                            </div>
                        </div>
                    </ModalCaixa>

                    <ModalMoeda
                        isOpen={showformmoeda}
                        onRequestClose={() => setshowformmoeda(false)}
                        overlayClassName="modal-overlay"
                        className="modal-content modal-xl"
                    >
                        <div className="container-fluid h-100">
                            <div className="modal-header">
                                {novomoeda ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
                                <button type="button" className="btn-close" onClick={() => setshowformmoeda(false)}></button>
                            </div>

                            <div className="modal-body">
                                <form>
                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-floating">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    id="moeda"
                                                    value={moeda}
                                                    onChange={(e) => setMoeda(e.target.value)}
                                                />
                                                <label htmlFor="moeda">Moeda</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2'>
                                            <div className="form-group">
                                                <label className="form-label">Tipo de Moeda</label>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="dinheiro"
                                                        name="tipomoeda"
                                                        value="DI"
                                                        checked={tipoMoeda === "DI"}
                                                        onChange={(e) => setTipoMoeda(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="dinheiro">
                                                        Dinheiro
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="pix"
                                                        name="tipomoeda"
                                                        value="PX"
                                                        checked={tipoMoeda === "PX"}
                                                        onChange={(e) => setTipoMoeda(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="pix">
                                                        Pix
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="cartaodebito"
                                                        name="tipomoeda"
                                                        value="CD"
                                                        checked={tipoMoeda === "CD"}
                                                        onChange={(e) => setTipoMoeda(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="cartaodebito">
                                                        Cartão Débito
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="cartaocredito"
                                                        name="tipomoeda"
                                                        value="CC"
                                                        checked={tipoMoeda === "CC"}
                                                        onChange={(e) => setTipoMoeda(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="cartaocredito">
                                                        Cartão Crédito
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="boleto"
                                                        name="tipomoeda"
                                                        value="BO"
                                                        checked={tipoMoeda === "BO"}
                                                        onChange={(e) => setTipoMoeda(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="boleto">
                                                        Boleto
                                                    </label>
                                                </div>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        id="promissoria"
                                                        name="tipomoeda"
                                                        value="PR"
                                                        checked={tipoMoeda === "PR"}
                                                        onChange={(e) => setTipoMoeda(e.target.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor="promissoria">
                                                        Promissoria
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" onClick={() => setshowformmoeda(false)}>
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-success" onClick={SalvarMoeda}>
                                    Salvar
                                </button>

                            </div>
                        </div>
                    </ModalMoeda>

                    <div className="container-fluid py-4 d-flex flex-column" style={{ minHeight: '100vh' }}>
                        <Title text="Contas a Receber" icon="user" />
                        <Description text="Operação para registrar as receitas da empresa, o contas a receber." />

                        <div className="row">
                            <div className="col-xl-4 col-lg-6 col-md-8 col-sm-12">
                                <SearchField
                                    value={search}
                                    onChange={setSearch}
                                    placeholder="Buscar despesas por: Código, responsável, caixa, condição, categoria ou histórico"
                                />
                            </div>

                            <div className="col-xl-3 col-lg-6 col-md-4 col-sm-12 mb-2">
                                <div className="d-flex flex-wrap gap-2" role="group" aria-label="Filtro de status">
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="filtro"
                                        id="filtroTodos"
                                        value="T"
                                        checked={filtroBusca === "T"}
                                        onChange={(e) => setFiltroBusca(e.target.value)}
                                    />
                                    <label className="btn btn-outline-primary" htmlFor="filtroTodos">
                                        Todos
                                    </label>

                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="filtro"
                                        id="filtroVencidos"
                                        value="V"
                                        checked={filtroBusca === "V"}
                                        onChange={(e) => setFiltroBusca(e.target.value)}
                                    />
                                    <label className="btn btn-outline-primary" htmlFor="filtroVencidos">
                                        Vencidos
                                    </label>

                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="filtro"
                                        id="filtroAberto"
                                        value="A"
                                        checked={filtroBusca === "A"}
                                        onChange={(e) => setFiltroBusca(e.target.value)}
                                    />
                                    <label className="btn btn-outline-primary" htmlFor="filtroAberto">
                                        Em Aberto
                                    </label>

                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="filtro"
                                        id="filtroPago"
                                        value="P"
                                        checked={filtroBusca === "P"}
                                        onChange={(e) => setFiltroBusca(e.target.value)}
                                    />
                                    <label className="btn btn-outline-primary" htmlFor="filtroPago">
                                        Pago
                                    </label>
                                </div>
                            </div>

                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                                <DuasDatas
                                    value1={dt1}
                                    onChange1={setdt1}
                                    value2={dt2}
                                    onChange2={setdt2}
                                />
                            </div>

                            <div className="col-xl-2 col-lg-6 col-md-6 col-sm-12 text-center">
                                <AddButton onClick={handleAdd} text="Nova Receita" disabled={!podeInserir("/ope/contasreceber")}/>
                            </div>
                        </div>

                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}

                        {/* Corpo principal com flex-grow */}

                        <div className="flex-grow-1 d-flex flex-column">
                            {loading ? (
                                <div className="text-center py-4 flex-grow-1 d-flex align-items-center justify-content-center">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Carregando...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="table-wrapper flex-grow-1 d-flex flex-column">
                                    <Table
                                        columns={columns}
                                        data={data}
                                        onEdit={handleEdit}
                                        isEditDisabled={() => !podeEditar("/ope/contasreceber")}
                                        onDelete={handleOpen}
                                        isDeleteDisabled={() => !podeExcluir("/ope/contasreceber")}
                                        menuActions={menuOptions}
                                        extraIcons={extraIcons}
                                        showFooter={true}
                                    />
                                </div>

                            )}
                        </div>

                        {/* Pagination no rodapé */}
                        <Pagination
                            currentPage={currentPage}
                            totalPages={pagination.totalPages}
                            onPageChange={setCurrentPage}
                            perPage={perPage}
                            onPerPageChange={handlePerPageChange}
                            total={pagination.total}
                        />

                    </div>
                </main>
            </div>
        </>
    );
};

export default OpeContasReceber;